import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';
interface IProps {
  color?: string;
  size?: number;
}
const SuccessTickIcon = ({
  size = 32,
  color = Styles.Colors.PayNew.success,
}: IProps) => (
  <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 2.667C8.637 2.667 2.666 8.637 2.666 16S8.636 29.334 16 29.334c7.363 0 13.333-5.97 13.333-13.334 0-7.363-5.97-13.333-13.333-13.333zm6.84 8.875l-8.28 10.625c-.066.065-.173.208-.304.208-.137 0-.226-.095-.304-.172-.077-.078-4.696-4.518-4.696-4.518l-.09-.09a.349.349 0 01-.065-.19c0-.071.03-.137.066-.19a488.85 488.85 0 011.512-1.59c.077-.077.142-.178.285-.178.149 0 .244.125.316.196.071.072 2.678 2.578 2.678 2.578l6.625-8.512a.34.34 0 01.209-.084c.077 0 .148.03.208.078l1.821 1.434c.048.06.078.131.078.208a.31.31 0 01-.06.197z"
      fill={color}
    />
  </Svg>
);
export default SuccessTickIcon;
